import type React from 'react';
import { type ModalContentProps } from '../state';
import { DemoModal, MapModal } from './modals';

const Noop = () => null;

const MODALS: Record<string, React.FC<ModalContentProps>> = {
  demo: DemoModal,
  map: MapModal,
};

export const getModalContent = (
  modalType: string | null,
): React.FC<ModalContentProps> => MODALS[modalType || ''] || Noop;
